import { render, staticRenderFns } from "./UpdateAdoption.vue?vue&type=template&id=6f5c04e7&scoped=true&"
import script from "./UpdateAdoption.vue?vue&type=script&lang=js&"
export * from "./UpdateAdoption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c04e7",
  null
  
)

export default component.exports